import { render, staticRenderFns } from "./add-time-slot.vue?vue&type=template&id=20de2ac8&"
import script from "./add-time-slot.vue?vue&type=script&lang=js&"
export * from "./add-time-slot.vue?vue&type=script&lang=js&"
import style0 from "./add-time-slot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports